module.exports = __webpack_public_path__ + "img/search-header-with-nav-toyota.546af187.png";